import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { QUOTE_CONTEXTS } from '@bytel/checkout';

import { REGEXS } from '@base/common/constants/index';

export class PhoneRegex {
    private readonly _regExp: RegExp;

    constructor(context: string) {
        this._regExp = context === QUOTE_CONTEXTS.ACQUISITIONFIX ? REGEXS.FAI_REGEX : REGEXS.MOBILE_REGEXP;
    }

    public getRegExpValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control.value && !control.value.toString().match(this._regExp)) {
                return { phone: 'Ce numéro est incorrect. Merci de le vérifier et essayer à nouveau' };
            }
            return null;
        };
    }
}
